"use client";

import colors from "@/constants/colors";
import { usePathname } from "next/navigation";
import { NavLinkItem } from "./NavBar.styled";

export default function NavLink({ href, children }: { href: string; children: React.ReactNode }) {
  const pathname = usePathname();
  const isActive = pathname === href || pathname.startsWith(`${href}/`);

  const linkStyle = () => (isActive ? { backgroundColor: "white", color: colors.text } : {});

  return (
    <NavLinkItem href={href} style={linkStyle()}>
      {children}
    </NavLinkItem>
  );
}
